export const ALL_DEPARTAMENTS = "ALL";

export const normalizeLseDepartmentId = lseDepartmentId =>
    lseDepartmentId === ALL_DEPARTAMENTS ? null : lseDepartmentId;
